export const SELECT_ROLE = "@userRole/SELECT_ROLE";

export const INITIALIZE_CREATE_ROLE = "@userRole/INITIALIZE_CREATE_ROLE";

export const UPDATE_NAME = "@userRole/UPDATE_NAME";
export const UPDATE_STATUS = "@userRole/UPDATE_STATUS";
export const UPDATE_PERMISSIONS = "@userRole/UPDATE_PERMISSIONS";

export const GET_ROLE_REQUEST = "@userRole/GET_ROLE_REQUEST";
export const GET_ROLE_SUCCESS = "@userRole/GET_ROLE_SUCCESS";
export const GET_ROLE_FAILURE = "@userRole/GET_ROLE_FAILURE";

export const GET_DETAIL_ROLE_REQUEST = "@userRole/GET_DETAIL_ROLE_REQUEST";
export const GET_DETAIL_ROLE_SUCCESS = "@userRole/GET_DETAIL_ROLE_SUCCESS";
export const GET_DETAIL_ROLE_FAILURE = "@userRole/GET_DETAIL_ROLE_FAILURE";

export const SAVE_ROLE_REQUEST = "@userRole/SAVE_ROLE_REQUEST";
export const SAVE_ROLE_SUCCESS = "@userRole/SAVE_ROLE_SUCCESS";
export const SAVE_ROLE_FAILURE = "@userRole/SAVE_ROLE_FAILURE";

export const CREATE_ROLE_REQUEST = "@userRole/CREATE_ROLE_REQUEST";
export const CREATE_ROLE_SUCCESS = "@userRole/CREATE_ROLE_SUCCESS";
export const CREATE_ROLE_FAILURE = "@userRole/CREATE_ROLE_FAILURE";